module.exports = __webpack_public_path__ + "media/bg.49ebef30.mp3";